import { render } from "./BaseDateRangeSelector.vue?vue&type=template&id=1dba5070"
import script from "./BaseDateRangeSelector.vue?vue&type=script&lang=js"
export * from "./BaseDateRangeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__